<template>
  <div>
    <v-card class="px-4 py-2 mt-4 rounded-lg">
      <v-row>
        <v-col md="6">
          <v-label class="label"> {{ $t("Vision Enable") }}</v-label>
          <v-switch
            v-model="localForm.visionEnabled"
            @change="onChange('visionEnabled', localForm.visionEnabled)"
            class="form-switch"
            inset
            hide-details
          ></v-switch>
        </v-col>
        <v-col md="6">
          <v-select
            outlined
            dense
            hide-details
            v-model="localForm.generation"
            @change="onChange('gen', localForm.generation)"
            :items="generationItems"
            class="form-select"
            :label="$t('Generation *')"
            :placeholder="$t('Select Generation')"
            attach
          >
          </v-select>
        </v-col>
        <v-col md="6">
          <v-select
            outlined
            dense
            hide-details
            v-model="localForm.cameraType"
            @change="onChange('cameraType', localForm.cameraType)"
            :items="cameraTypes"
            class="form-select"
            :label="$t('Camera Type *')"
            :placeholder="$t('Select Generation')"
            attach
          >
          </v-select>
        </v-col>
        <v-col md="6">
          <v-label class="label"> {{ $t("Vision Status") }}</v-label>
          <v-switch
            v-model="localForm.visionStatus"
            @change="onChange('visionStatus', localForm.visionStatus)"
            :label="$t('Active')"
            class="form-switch"
            inset
            hide-details
          ></v-switch>
        </v-col>
      </v-row>
    </v-card>
    <v-card elevation="2" class="px-4 py-2 mt-4 rounded-lg">
      <v-card-title class="pa-0">
        <div class="section-heading">{{ $t("DETECTION") }}</div>
      </v-card-title>
      <v-row>
        <v-col md="5">
          <v-select
            outlined
            dense
            hide-details
            v-model="localForm.oosPageChange"
            @change="onChange('oosPageChange', localForm.oosPageChange)"
            :items="oosPageItems"
            :item-text="'name'" :item-value="'value'"
            class="form-select"
            :label="$t('OOS Page *')"
            :placeholder="$t('Select Generation')"
            attach
          >
          </v-select>
        </v-col>
      </v-row>
      <div class="section-description">
        {{ $t("Display page when out-of-stock is detected") }}
      </div>
    </v-card>
    <v-card elevation="2" class="px-4 py-2 mt-4 mb-4 rounded-lg">
      <v-card-title class="pa-0">
        <div class="section-heading">{{ $t("NOTIFICATIONS & ALERTS") }}</div>
      </v-card-title>
      <v-card-text class="mt-4 pa-0">
        <!-- <div class="d-flex justify-space-between">
          <div>
            <div class="alert-title">{{ $t("Switch On Shelf") }}</div>
            <div class="section-description">
              {{ $t("Trigger alerts when shelf state switches") }}
            </div>
          </div>
          <v-switch
            v-model="localForm.onShelf"
            @change="onChange('onShelf', localForm.onShelf)"
            class="form-switch"
            inset
            hide-details
          ></v-switch>
        </div> -->
        <div class="d-flex justify-space-between mt-4">
          <div>
            <div class="alert-title">{{ $t("OOS Alert") }}</div>
            <div class="section-description">
              {{ $t("Out-of-stock notification") }}
            </div>
          </div>
          <v-switch
            v-model="localForm.oosAlert"
            @change="onChange('oosAlert', localForm.oosAlert)"
            class="form-switch"
            inset
            hide-details
          ></v-switch>
        </div>
        <div class="d-flex justify-space-between mt-4">
          <div>
            <div class="alert-title">{{ $t("MIS Alert") }}</div>
            <div class="section-description">
              {{ $t("Misplacement notification") }}
            </div>
          </div>
          <v-switch
            v-model="localForm.misAlert"
            @change="onChange('misAlert', localForm.misAlert)"
            class="form-switch"
            inset
            hide-details
          ></v-switch>
        </div>
        <div class="d-flex justify-space-between mt-4">
          <div>
            <div class="alert-title">{{ $t("LOW Alert") }}</div>
            <div class="section-description">
              {{ $t("Low stock level notification") }}
            </div>
          </div>
          <v-switch
            v-model="localForm.lowAlert"
            @change="onChange('lowAlert', localForm.lowAlert)"
            class="form-switch"
            inset
            hide-details
          ></v-switch>
        </div>
      </v-card-text>
    </v-card>
    <v-expansion-panels
      flat
      accordion
      class="advancedSetting"
      v-model="showShelfConfig"
    >
      <v-expansion-panel>
        <v-expansion-panel-header class="pl-0 pr-0"
          ><i class="throwline"></i
          >{{ $t("Shelf Config") }}</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <div>
            <h3 class="section-subheading">{{ $t("ESL") }}</h3>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="localForm.esl1"
                  @change="onChange('esl1', localForm.esl1)"
                  :label="$t('Detect Confidence: Locate ESL Threshold *')"
                  class="form-input"
                  outlined
                  dense
                  hide-details="auto"
                  type="number"
                >
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="localForm.esl2"
                  @change="onChange('esl2', localForm.esl2)"
                  :label="$t('Locate ESL Threshold (Upper) *')"
                  class="form-input"
                  outlined
                  dense
                  hide-details="auto"
                  type="number"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <div>
            <h3 class="section-subheading">{{ $t("PRODUCT") }}</h3>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="localForm.product1"
                  @change="onChange('product1', localForm.product1)"
                  :label="$t('Detect Confidence: Locate Product *')"
                  class="form-input"
                  outlined
                  dense
                  hide-details="auto"
                  type="number"
                >
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="localForm.product2"
                  @change="onChange('product2', localForm.product2)"
                  :label="$t('Misplacemnet Threshold: MPI *')"
                  class="form-input"
                  outlined
                  dense
                  hide-details="auto"
                  type="number"
                >
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="localForm.product3"
                  @change="onChange('product3', localForm.product3)"
                  :label="$t('Cluster Misplacemnet Threshold: MPI *')"
                  class="form-input"
                  outlined
                  dense
                  hide-details="auto"
                  type="number"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <div>
            <h3 class="section-subheading">{{ $t("REPORTS") }}</h3>
            <v-row>
              <v-col cols="6">
                <v-card elevation="2" class="pa-4 rounded-lg">
                  <div class="d-flex justify-space-between">
                    <div>
                      <div class="alert-title">{{ $t("Restock Shelf") }}</div>
                      <div class="config-text">
                        {{ $t("Trigger restocking workflow") }}
                      </div>
                    </div>
                    <v-switch
                      v-model="localForm.restockShelf"
                      @change="onChange('restockShelf', localForm.restockShelf)"
                      class="form-switch"
                      inset
                      hide-details
                    ></v-switch>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card elevation="2" class="pa-4 rounded-lg">
                  <div class="d-flex justify-space-between">
                    <div>
                      <div class="alert-title">{{ $t("OOS Report") }}</div>
                      <div class="config-text">
                        {{ $t("Out-of-stock report generation") }}
                      </div>
                    </div>
                    <v-switch
                      v-model="localForm.ossReport"
                      @change="onChange('ossReport', localForm.ossReport)"
                      class="form-switch"
                      inset
                      hide-details
                    ></v-switch>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card elevation="2" class="pa-4 rounded-lg">
                  <div class="d-flex justify-space-between">
                    <div>
                      <div class="alert-title">{{ $t("MIS Report") }}</div>
                      <div class="config-text">
                        {{ $t("Misplacement report generation") }}
                      </div>
                    </div>
                    <v-switch
                      v-model="localForm.misReport"
                      @change="onChange('misReport', localForm.misReport)"
                      class="form-switch"
                      inset
                      hide-details
                    ></v-switch>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="6">
                <v-card elevation="2" class="pa-4 rounded-lg">
                  <div class="d-flex justify-space-between">
                    <div>
                      <div class="alert-title">{{ $t("LS Report") }}</div>
                      <div class="config-text">
                        {{ $t("Low stock report generation") }}
                      </div>
                    </div>
                    <v-switch
                      v-model="localForm.reportLS"
                      @change="onChange('reportLS', localForm.reportLS)"
                      class="form-switch"
                      inset
                      hide-details
                    ></v-switch>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  props: ['value'],

  data () {
    return {
      localForm: null,
      generationItems: ['GEN2'],
      cameraTypes: ['Shelf'],
      oosPageItems: [],
      showShelfConfig: false
    }
  },
  watch: {
    value: {
      handler () {
        this.localForm = this.value
        console.log('Vision Config Loaded:', this.localForm)
      },
      immediate: true
    }
  },
  methods: {
    onChange (key, value) {
      this.$emit('input', {
        ...this.localForm,
        [key]: value
      })
    },
    getpropertydetails () {
      const url = '/api/common/property'
      this.$utils.callAxios('get', url).then((res) => {
        if (res.data) {
          this.oosPageItems = Array.from({ length: res.data.aimsPortalBiz1MaxPage }, (_, index) => index + 1)
        }
      })
    }
  },
  mounted () {
    this.getpropertydetails()
  }
}
</script>

<style scoped>
.section-heading {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #0a2640;
}

.alert-title {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #0a2640;
  margin-bottom: 4px;
}

.label {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: rgba(10, 38, 64, 0.9) !important;
}

.v-label {
  font-size: 12px;
}

.section-subheading {
  font-size: 14px;
  font-weight: 700;
  margin: 20px 0 10px;
  color: #0a2640;
  letter-spacing: 0.02em;
}

.section-description,
.config-text {
  font-size: 13px;
  color: rgba(10, 38, 64, 0.7);
  line-height: 1.6;
  margin-top: 4px;
}
</style>
